module.exports = __webpack_public_path__ + "media/images/official/kv_sp1-a0ee435ebcd095a52053e8e16158db25.webp";